/**
 * 区域组件：区域 - 国家 输入表单用
 * @Author: fjj
 * @History:
 * @Date      Version Remarks
 * ========= ======= ======================================================
 * 2022.05.21      1.0     First version
 *
 * @param onCountryClicked  当点击后回调(CountryId)
 * @param onCityClicked   选择城市 回调城市数组
 *
 * Copyright 2022, all rights reserved. Essa.cn
 */
import React from 'react';
import { Form, Row, Col, Select } from 'antd';
import { isEmpty,isEmptyObject } from "@utils/utils";
import RegionService from "./Region.action";
import PropTypes from "prop-types";
import Lang from "@/components/Lang/Lang";
const { Option } = Select;
const FormItem = Form.Item;
class Region extends React.Component {
    static propTypes = {
        hidden: PropTypes.bool,
    }
    static defaultProps = {
        hidden:false,
        size:"default",
    }
    constructor(props) {
        super(props);
        this.state={
            listCountry :[],
            subList: [],
            loading: false,
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 请求地区列表
     * */
    getSaleMarketList(){
        const sUrl = "/service/fenxiao/buyer/queryAllCountry";
        this.loading(true)
        RegionService.postHttpAction(sUrl,{}).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));

    }
    handleRes(resData){
        const { success, valid, models=[], } = resData;
        this.loading(false)
        if (success && valid) {
            if(models&&models.length>0){
                const { initValue={} } = this.props;
                let subList = []
                if(!isEmpty(initValue.saleMarketId)){
                    const current = models.find(item=>item.code==initValue.saleMarketId)||{};
                    if(!isEmptyObject(current)){
                        subList = current.countryList ||[]
                    }
                }
                this.setState({
                    listCountry : models||[],
                    subList:subList
                })
            }
        }
    }
    // // 输出
    // renderOptions(list=[]){
    //     const enumChildren = [];
    //     list.forEach((area,inx)=>{
    //         enumChildren.push(<Option key={area.id+'_'+inx} value={area.id} telCode={area.telCode} label={'+'+area.telCode}>+{area.telCode}<span>{area.name}</span></Option>);
    //     })
    //     return enumChildren;
    // }
    /**
     * 选择国家
     * */
    handleCountryChange = (value,option) => {
        if(value){
            const { listCountry } =this.state;
            const current = listCountry.find(item=>item.code==value)||{}
            const countryCode = current.code;
            const subList = current.countryList||[];
            if(this.props.onChange)this.props.onChange(countryCode);
            if(this.props.clearSubRegion)this.props.clearSubRegion('countries');
           this.setState({
               currentSaleMarket :value,
               subList:subList,
           })
        }else {
            if(this.props.onChange)this.props.onChange('');
            if(this.props.clearSubRegion)this.props.clearSubRegion('countries');
            this.setState({
                currentSaleMarket :'',
                subList: []
            })
        }

    };

    componentWillMount() {
        this.getSaleMarketList();
    }
    componentDidMount() {
        if( this.props.onRef)  this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { disabled,required, formItemLayout,title,showSubTitle,hidden,size } = this.props;
        const { listCountry, subList, loading } = this.state;
        return ( <Row gutter={16}>
                    <Col span={12}>
                        <FormItem  {...formItemLayout}  name={'saleMarketId'} label={title}
                                   hidden={hidden}
                                   rules={[{ required:required? true:false, message: __getServerLanguage("QingXuanZeQuYu")}]}>
                            <Select showSearch
                                    size={size}
                                   disabled={disabled}
                                   filterOption={(input, option) =>option.text.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                   allowClear
                                   loading={loading}
                                   placeholder={Lang({id:"QingXuanZe2",default:"请选择"})} // 请选择区域 QingXuanZeQuYu
                                   onChange={(value,option)=>this.handleCountryChange(value,option)} >
                            {listCountry.map(saleMarket => (
                                <Option key={saleMarket.code+''} value={saleMarket.code+''} text={saleMarket.name}>
                                    <span className={'margin-left-5'}>{saleMarket.name}</span>
                                </Option>
                            ))}
                        </Select>
                        {/*)}*/}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} name={'countries'} label={showSubTitle||' '} className={"noStarItem"}
                                  hidden={hidden}
                                  rules={[{ required:required? true:false, message: __getServerLanguage("QingXuanZeGuoJia2")}]}>
                            <Select size={size}
                            showSearch
                            filterOption={(input, option) =>option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            allowClear
                            disabled={disabled}
                            placeholder={Lang({id:"QingXuanZe2",default:"请选择"})} //请选择国家 QingXuanZeGuoJia2
                                       >
                            {subList.map(city => (
                                <Option key={city.code} value={city.code}>{city.name}</Option>
                            ))}
                        </Select>
                            {/*)}*/}
                        </FormItem>
                    </Col>
                    </Row>)
    }
}
export default Region;
